import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { Grid } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MDButton from 'components/MDButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { CheckCircle, Warning, Error, Info, Undo, Description } from '@mui/icons-material';
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useApi } from "lib/api";

export default function DevolverMatricula() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { post } = useApi();
  const [open, setOpen] = useState(false);
  
  // Estados principales
  const [sucursales, setSucursales] = useState([]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  const [chasisSeleccionado, setChasisSeleccionado] = useState("");
  const [chasisDisponibles, setChasisDisponibles] = useState([]);
  const [comentario, setComentario] = useState("");
  const [cargando, setCargando] = useState(false);

  // Estados para tipos de documentos
  const [tiposDocumentos, setTiposDocumentos] = useState([
    { value: 'placa', label: 'Placa', estado: false, entregado: false },
    { value: 'matricula', label: 'Matrícula', estado: false, entregado: false },
  ]);
  const [tiposSeleccionados, setTiposSeleccionados] = useState([]);

  // Estados para el diálogo de notificaciones
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogMessage, setDialogMessage] = useState('');
  const [dialogType, setDialogType] = useState('info');

  // Función para mostrar diálogo de notificación
  const showDialog = (title, message, type = 'info') => {
    setDialogTitle(title);
    setDialogMessage(message);
    setDialogType(type);
    setDialogOpen(true);
  };

  // Función para cerrar el diálogo
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  // Función para cargar sucursales
  const cargarSucursales = () => {
    setSucursales([
      { label: localStorage.getItem('sucursal'), value: localStorage.getItem('sucursal') },
    ]);
    setSucursalSeleccionada(localStorage.getItem('sucursal'));
  };

  // Función para cargar chasis disponibles
  const cargarChasisDisponibles = () => {
    post('/api/consultarmatricula', {
      'sucursal': localStorage.getItem('sucursal')
    })
      .then(function ({ status, data }) {
        if (status === 200) {
          setChasisDisponibles(data["matriculas2"] || []);
        } else {
          showDialog('Error', 'Error al cargar los chasis disponibles', 'error');
        }
      })
      .catch(function (error) {
        showDialog('Error', 'Error de conexión: ' + error.message, 'error');
      });
  };

  // Función para seleccionar chasis y cargar documentos disponibles
  const seleccionarChasis = (event, newValue) => {
    
    setChasisSeleccionado(newValue?.chasis || '');
    if (newValue && newValue.sucursaldocumentos && newValue.sucursaldocumentos.length > 0) {
      // Cargar documentos disponibles para el chasis seleccionado
      cargarDocumentosDisponibles(newValue.chasis, newValue.sucursaldocumentos);
    } else {
      // Resetear tipos de documentos si no hay documentos
      setTiposDocumentos([
        { value: 'placa', label: 'Placa', estado: true, entregado: true },
        { value: 'matricula', label: 'Matrícula', estado: true, entregado: true },
      ]);
      setTiposSeleccionados([]);
    }
  };

  // Función para cargar documentos disponibles
  const cargarDocumentosDisponibles = (chasis, sucursaldocumentos) => {
    console.log("manuel7",sucursaldocumentos)
    try {
      const documentosData = JSON.parse(sucursaldocumentos);
      
      if (documentosData.documentos) {
        const existeasterisco = documentosData.documentos.includes('*');
        
        if (existeasterisco) {
          // Hay varios documentos
          const documentos = documentosData.documentos.split('*');
          let nuevosTiposDocumentos = [...tiposDocumentos];

          documentos.forEach(item => {
            const docData = JSON.parse(item);
            nuevosTiposDocumentos = nuevosTiposDocumentos.map(tipo => {
                if (tipo.value !== docData.documento) {
                return {
                  ...tipo,
                  estado: false,
                  entregado: docData.entregado
                };
              } else {
                return tipo;
              }
            });
          });
          
          setTiposDocumentos(nuevosTiposDocumentos);
        } else {
          // Solo hay un documento
          const docData = JSON.parse(documentosData.documentos);
          const nuevosTiposDocumentos = tiposDocumentos.map(tipo => {
            if (tipo.value !== docData.documento) {
              return {
                ...tipo,
                estado: true,
                entregado: docData.entregado
              };
            } else {
              return tipo;
            }
          });
          
          setTiposDocumentos(nuevosTiposDocumentos);
                      
        }
      } else {
        // No hay documentos
        setTiposDocumentos([
          { value: 'placa', label: 'Placa', estado: false, entregado: false },
          { value: 'matricula', label: 'Matrícula', estado: false, entregado: false },
        ]);
        
      }
      
      setTiposSeleccionados([]);
      
    } catch (error) {
      showDialog('Error', 'Error al procesar los documentos del chasis', 'error');
    }
  };

  // Función para procesar la devolución de documentos
  const procesarDevolucion = () => {
    console.log(tiposSeleccionados,"manuel4");
    if (!chasisSeleccionado) {
      showDialog('Validación Requerida', 'Debe seleccionar un chasis', 'warning');
      return;
    }

    if (tiposSeleccionados.length === 0) {
      showDialog('Validación Requerida', 'Debe seleccionar al menos un tipo de documento para devolver', 'warning');
      return;
    }

    if (!comentario.trim()) {
      showDialog('Validación Requerida', 'Debe ingresar un comentario para la devolución', 'warning');
      return;
    }

    setCargando(true);

    post('/api/transferenciabackend_procesardevolucion', {
      'documentoadevolver': tiposSeleccionados,
      'chasis': chasisSeleccionado,
      'comentario': comentario,
    })
    .then(function ({ status, data }) {
      if (status === 200) {
        showDialog('OK', 'Devolución de documentos completada', 'success');
      } else {
          showDialog('Error', 'Error al cargar los chasis disponibles', 'error');
      }
    })
    .catch(function (error) {
      showDialog('Error', 'Error de conexión: ' + error.message, 'error');
    });




    // Simular la devolución de documentos
    setTimeout(() => {
      setCargando(false);
      const tiposResumen = tiposSeleccionados.map(tipo => 
        tiposDocumentos.find(t => t.value === tipo)?.label
      ).join(', ');
      
      showDialog('Éxito', `Devolución de documentos completada: ${tiposResumen}`, 'success');
      
      // Limpiar formulario
      setTiposSeleccionados([]);
      setComentario("");
      setChasisSeleccionado("");
    }, 2000);
  };

  // Función para limpiar la selección
  const limpiarSeleccion = () => {
    setTiposSeleccionados([]);
    setComentario("");
    setChasisSeleccionado("");
    setTiposDocumentos([
      { value: 'placa', label: 'Placa', estado: false, entregado: false },
      { value: 'matricula', label: 'Matrícula', estado: false, entregado: false },
    ]);
  };

  useEffect(() => {
    cargarSucursales();
  }, []);

  useEffect(() => {
    if (sucursalSeleccionada) {
      cargarChasisDisponibles();
    }
  }, [sucursalSeleccionada]);

  return (
    <Box>
      <Box mt={1} mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60vh',
                padding: 3,
                backgroundColor: 'white',
                borderRadius: 2,
                boxShadow: 1
              }}
            >
              <Typography variant="h4" component="h1" gutterBottom color="primary">
                <Undo sx={{ mr: 1, verticalAlign: 'middle' }} />
                Devolver Documentos de Matrícula
              </Typography>
              
              <Typography variant="body1" color="textSecondary" sx={{ mb: 4, textAlign: 'center' }}>
                Seleccione la sucursal, chasis y los documentos que desea devolver a su sucursal de origen
              </Typography>

              <Grid container spacing={3} sx={{ width: '100%', maxWidth: 1200 }}>
                {/* Selección de sucursal */}
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={sucursales}
                    getOptionLabel={(option) => option.label || ''}
                    value={sucursales.find(s => s.label === sucursalSeleccionada) || null}
                    disableClearable
                    disabled={true}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Sucursal Origen Documentos"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </Grid>

                {/* Selección de chasis */}
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={chasisDisponibles}
                    getOptionLabel={(option) => option.chasis || ''}
                    value={chasisDisponibles.find(ch => ch.chasis === chasisSeleccionado) || null}
                    onChange={seleccionarChasis}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Seleccionar Chasis"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </Grid>

                {/* Selección de tipos de documentos */}
                {chasisSeleccionado && (
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Documentos Disponibles para Devolución
                    </Typography>
                    <Box sx={{ 
                      border: "1px solid #ccc", 
                      borderRadius: 2, 
                      padding: 2, 
                      backgroundColor: "#f9f9f9" 
                    }}>
                      {tiposDocumentos.map((tipo) => {
                        const isChecked = tiposSeleccionados.includes(tipo.value);
                        const isDisabled = tipo.estado; // Solo disponibles si no están entregados
                        return (
                          <Box key={tipo.value} sx={{ 
                            display: "flex", 
                            alignItems: "center", 
                            marginBottom: 1,
                            opacity: isDisabled ? 0.5 : 1
                          }}>
                            <input
                              type="checkbox"
                              id={`tipo-${tipo.value}`}
                              checked={isChecked}
                              disabled={isDisabled}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setTiposSeleccionados([...tiposSeleccionados, tipo.value]);
                                } else {
                                  setTiposSeleccionados(tiposSeleccionados.filter(t => t !== tipo.value));
                                }
                              }}
                              style={{
                                marginRight: "8px",
                                cursor: isDisabled ? "not-allowed" : "pointer"
                              }}
                            />
                            <label 
                              htmlFor={`tipo-${tipo.value}`} 
                              style={{
                                cursor: isDisabled ? "not-allowed" : "pointer", 
                                fontSize: "14px",
                                color: isDisabled ? "red" : "#000"
                              }}
                            >
                              {tipo.label}
                                {isDisabled && (
                                    <span style={{fontSize: "12px", color: "red", marginLeft: "5px"}}>
                                    (Documento no disponible para devolucion)
                                    </span>
                                )}
                            </label>
                          </Box>
                        );
                      })}
                    </Box>
                    {tiposSeleccionados.length > 0 && (
                      <Typography variant="body2" sx={{ marginTop: 1, color: "#666" }}>
                        Seleccionados: {tiposSeleccionados.map(tipo => 
                          tiposDocumentos.find(t => t.value === tipo)?.label
                        ).join(', ')}
                      </Typography>
                    )}
                  </Grid>
                )}

                {/* Comentario */}
                <Grid item xs={12}>
                  <TextField
                    label="Comentario de Devolución"
                    multiline
                    rows={3}
                    value={comentario}
                    onChange={(e) => setComentario(e.target.value)}
                    fullWidth
                    variant="outlined"
                    placeholder="Ingrese el motivo de la devolución de documentos..."
                  />
                </Grid>

                {/* Botones de acción */}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                    <MDButton
                      variant="gradient"
                      color="success"
                      size="large"
                      onClick={procesarDevolucion}
                      disabled={tiposSeleccionados.length === 0 || cargando || !chasisSeleccionado}
                      startIcon={<Undo />}
                    >
                      {cargando ? 'Procesando...' : 'Devolver Documentos'}
                    </MDButton>
                    
                    <MDButton
                      variant="gradient"
                      color="warning"
                      size="large"
                      onClick={limpiarSeleccion}
                      disabled={cargando}
                    >
                      Limpiar Selección
                    </MDButton>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Diálogo de notificación */}
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
          {dialogType === 'success' && <CheckCircle color="success" sx={{ mr: 1 }} />}
          {dialogType === 'warning' && <Warning color="warning" sx={{ mr: 1 }} />}
          {dialogType === 'error' && <Error color="error" sx={{ mr: 1 }} />}
          {dialogType === 'info' && <Info color="info" sx={{ mr: 1 }} />}
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
